export class GuestRoleFilter {
    firstName: string;
    lastName: string;
    roleId: string;
    includeInactive: string;
}